import { Axios, AxiosInstance } from 'axios';
import { envs } from '../utils/env';
const { appType } = envs;

const setupAxiosInterceptor = (axios: Axios) => {
	axios.interceptors.request.use(async (request) => {
		if (appType) {
			request.headers['appType'] = appType;
		}
		return request;
	});

	axios.interceptors.response.use(
		(response) => response,
		async (error) => {
			throw error;
		}
	);
};

export const initAxiosInterceptor = (axiosInstance: AxiosInstance[]) => {
	axiosInstance.forEach((element: AxiosInstance) => {
		setupAxiosInterceptor(element);
	});
};
